import { render, staticRenderFns } from "./CreditReturnRegistration.vue?vue&type=template&id=dc8488b2&scoped=true&"
import script from "./CreditReturnRegistration.vue?vue&type=script&lang=js&"
export * from "./CreditReturnRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CreditReturnRegistration.vue?vue&type=style&index=0&id=dc8488b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8488b2",
  null
  
)

export default component.exports